import { render } from "./DeductDialog.vue?vue&type=template&id=705e6630&ts=true"
import script from "./DeductDialog.ts?vue&type=script&lang=ts"
export * from "./DeductDialog.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__